import React, { useEffect } from "react";
import NavbarDoctorOffice from "../../NavbarDoctorOffice";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Row,
} from "reactstrap";
import TabContent from "@dhn/components/atoms/tab-content";
import CardHeaderTabs from "@dhn/components/molecules/card-header-tabs";
import useActions from "../use-actions";
import GeneralTab from "./tabs/GeneralTab";
import BranchTab from "./tabs/BranchTabs";
import TaxesTab from "./tabs/TaxesTab";
import LoadingDhn from "../../../../@dhn/components/Loading/LoadingDhn";
import UnsavedChangesModal from "@dhn/components/molecules/unsaved-changes-modal";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  CENTERS_ADMIN_ACCESS_MESSAGE,
  hasCentersAdminAccess,
} from "../access";
import DoctorsOfficePage from "../../components/DoctorsOfficePage";

export default function ManagementCenters({
  profile,
  user,
  center,
  dataDoctor,
}) {
  const history = useHistory();
  const { addToast } = useToasts();
  const hasAccess = hasCentersAdminAccess(dataDoctor);
  const [{ state, workTeamRows }, actions] = useActions({ hasAccess });

  useEffect(() => {
    if (hasAccess) return;

    addToast(CENTERS_ADMIN_ACCESS_MESSAGE, {
      appearance: "error",
      autoDismiss: true,
    });
    history.replace("/");
  }, [addToast, hasAccess, history]);

  if (!hasAccess) {
    return null;
  }

  return (
    <div className="animated fadeIn">
      <LoadingDhn isOpen={state?.isLoadingDhn} />
      <UnsavedChangesModal
        isOpen={Boolean(state?.pendingDiscardAction)}
        onContinueEditing={actions.cancelDiscard}
        onDiscard={actions.confirmDiscard}
        message="Tienes cambios que no se han guardado ni modificado."
        hint="Si continúas, los cambios realizados se perderán."
      />
      <NavbarDoctorOffice
        profile={profile}
        user={user}
        center={center}
        dataDoctor={dataDoctor}
      />
      <DoctorsOfficePage icon="fa-hospital-o" title="Consultorios Médicos">
        <Row form>
          <Col md={12}>
            <Card>
              <CardHeaderTabs
                active={state?.activeTab}
                onClick={(tab) => actions.onChange("activeTab", tab)}
                tabs={[
                  {
                    id: 1,
                    name: <div className="px-4">General</div>,
                  },
                  ...(state?.branchOffice?.length
                    ? [
                        {
                          id: 2,
                          name: <div className="px-4">Sucursal</div>,
                        },
                      ]
                    : []),
                  {
                    id: 3,
                    name: <div className="px-4">Impuestos</div>,
                  },
                ]}
              />
              <CardBody>
                <TabContent activeTab={state?.activeTab}>
                  {state?.activeTab === 1 && (
                    <GeneralTab
                      onChange={actions.onChange}
                      state={state.pharmacyProvider}
                      dataState={state}
                      addFile={actions.addFile}
                      onSaveCommon={actions.onSaveCommon}
                      params={actions?.params}
                      optionsPrintTypes={state.optionsPrintTypes}
                    />
                  )}
                  {state?.activeTab === 2 && (
                    <BranchTab
                      actions={actions}
                      onChange={actions.onChange}
                      stateBranch={state.branchOffice}
                      state={state}
                      workTeamRows={workTeamRows}
                      subTab={state.branchSubTab}
                      branchSelected={state.branchSelected}
                      modalAddAndEditIsOpen={state.modalAddAndEditIsOpen}
                      actionsButtonEditUser={actions?.actionsButtonEditUser}
                      addToast={actions.addToast}
                    />
                  )}
                  {state?.activeTab === 3 && (
                    <TaxesTab
                      onChange={actions.onChange}
                      {...{ dataDoctor, state }}
                    />
                  )}
                </TabContent>
              </CardBody>
              {(!state.branchSubTab || state.activeTab === 1) && (
                <CardFooter className="d-flex justify-content-between">
                  {!actions.params && (
                    <Button
                      className="btn-color-warning"
                      onClick={() => actions.actionButtonAddBranch()}
                    >
                      <i className="fa fa-plus"></i>
                      {" Asignar Sucursal"}
                    </Button>
                  )}
                  <div>
                    {actions.params > 0 && (
                      <Button
                        disabled={state.loadingOrCreateModification}
                        color="success"
                        className="btn-color-success"
                        onClick={() => actions.onSaveCommon()}
                      >
                        <i
                          className={
                            state.loadingOrCreateModification
                              ? "fa fa-spinner fa-spin"
                              : "fa fa-plus"
                          }
                        ></i>
                        {state.loadingOrCreateModification
                          ? " Cargando..."
                          : state.isNew
                            ? " Agregar"
                            : " Modificar"}
                      </Button>
                    )}
                    <Button
                      color="secondary"
                      className="btn-color-gray ml-2"
                      onClick={actions.requestGoBack}
                    >
                      <i className="fa fa-arrow-left" aria-hidden="true"></i>
                      {" Atras"}
                    </Button>
                  </div>
                </CardFooter>
              )}
            </Card>
          </Col>
        </Row>
      </DoctorsOfficePage>
    </div>
  );
}
